














import { defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
  props: {
    labelColor: {
      type: String as PropType<string>,
      required: false,
      default: "#888",
    },
    labelText: {
      type: String as PropType<string>,
      required: false,
      default: "",
    },
    checkedText: {
      type: String as PropType<string>,
      required: false,
      default: "ON",
    },
    uncheckedText: {
      type: String as PropType<string>,
      required: false,
      default: "OFF",
    },
    value: {
      type: Boolean as PropType<boolean>,
      required: true,
    }
  },
  setup(props, context){

    const toggleChanged = (changedValue: any) => {
      context.emit("toggle-changed", changedValue.value);
    }

    return {
      toggleChanged,
    };
  }
})
